import React from 'react';
import {connect} from 'react-redux';
import '../styles/css/pro.coach.css';
import {CoachSelection, CoachChat, UpgradeToPro} from '../components/Pro.Coach.Components';
import * as action from '../actions/CoachAction';
import {subscribe, unsubscribe} from '../fetch/PushFetch';
import {pageView, trackEvent} from '../util/tracking';

class Coach extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      coaches : null,
      chatLog : null,
      is_first: props.chatrooms.length===0,
      chat: '',
      last_chat : {date:'',is_admin:null},
      scrollDiv: null,
      pushDropdown: false,
    };
  }

  // need to fix this part once API is done
  // this is in case if user has only one chatroom
  componentWillMount(){
    let {chatrooms, userState, getCoaches, getChatLogs, chatroomId} = this.props;
    if(userState==='pro'){
      if(chatrooms.length===0){
        getCoaches();
      }else{
        getChatLogs(chatroomId);
        this.setState({
          coach: chatrooms[0].coach,
          pushSetting: chatrooms[0].noti_level
        });
      }
    }
    pageView();
  }

  componentWillReceiveProps(nextProps){
    if(this.props.coaches !== nextProps.coaches){
      this.setState({
        coaches: nextProps.coaches
      });
    }

    if(nextProps.chatrooms.length>0){
      if(!this.state.chatLog){
        let {chatLog} = nextProps;

        console.log("subscribing messages");
        this.props.subscribe(`edge-coaching-message-${nextProps.chatroomId}`);

        if(chatLog.length>0){
          let last_chat = {...this.state.last_chat};
          let chatArray = chatLog[chatLog.length-1].chatArray;
          last_chat.date = chatLog[chatLog.length-1].date;
          last_chat.is_admin = chatArray[chatArray.length-1].is_admin;
          this.setState({chatLog, last_chat});
        }else{ //empty chat case
          this.setState({
            chatLog: [],
            last_chat: {date:new Date(), is_admin:false},
            coach: nextProps.chatrooms[0].coach,
            pushSetting: nextProps.chatrooms[0].noti_level
          })
        }
      }
    }

  }

  shouldComponentUpdate(nextProps, nextState){
    if(this.state.is_first&&!nextState.is_first){
      return false;
    }

    if(this.state === nextState && this.props === nextProps){
      return false;
    }
    return true;
  }

  componentDidMount(){
    if(this.state.scrollDiv){
      let div = this.state.scrollDiv;
      div.scrollTop = div.scrollHeight - div.clientHeight;
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.chatLog !== this.props.chatLog){
      let div = this.state.scrollDiv;
      div.scrollTop = div.scrollHeight - div.clientHeight;
    }
  }

  componentWillUnmount(){
    console.log("unsubscribing in unmount");
    this.props.unsubscribe(`edge-coaching-message-${this.props.chatroomId}`);
  }

  onCoachSelect(evt){
    this.setState({
      selected : evt.currentTarget.id,
    })
  }

  onCoachSubmit(){
    this.props.postChatRooms(this.state.selected);
    this.setState({
      is_first: false
    })

    trackEvent("PREMIUM-COACH", "Click Start Coach", "");
  }

  onChatChange(evt){
    this.setState({
      chat: evt.currentTarget.value
    })
  }

  /*
    case 1: Chat log empty

    case 2: Chat on the same date as the last chat

    case 3: Chat on the different date as the last chat

    inner case of case2 and case3
        last author same as new chat author
        last author different as new chat author
  */
  onChatSubmit(){
    if(this.state.chat.trim().length===0){
      return;
    }
    let {postChat, chatroomId} = this.props;

    postChat({"message":{"contents":this.state.chat}}, chatroomId);
    this.setState({chat: ''});

  }

  onPushStateChange(evt){
    if(evt.target.value===this.state.pushSetting){
      return;
    }
    evt.preventDefault();
    let content = {
      "chatroom":{
        "noti_level": evt.target.value
      }
    };

    this.props.updatePushSetting(content, this.props.chatroomId);
    this.setState({
      pushSetting: evt.target.value
    })
  }

  onMouseEnter(evt){
    this.setState({
      pushDropdown: true
    })
  }

  onMouseLeave(evt){
    this.setState({
      pushDropdown: false
    })
  }

  onKeyPress(evt){
    if(evt.charCode===13){
      if(evt.shiftKey){
        // shift enter pressed
      }else{
        evt.preventDefault();
        this.onChatSubmit();
      }
    }
  }

  onSelect(evtKey, event){
    event.stopPropagation();
    event.preventDefault();
  }

  onToggle(){}

  render(){
    let selectHandlers = {
      onCoachSelect : this.onCoachSelect.bind(this),
      onCoachSubmit : this.onCoachSubmit.bind(this),
    }
    let chatHandlers = {
      onChatChange: this.onChatChange.bind(this),
      onChatSubmit: this.onChatSubmit.bind(this),
      onPushStateChange: this.onPushStateChange.bind(this),
      onKeyPress: this.onKeyPress.bind(this),
      onSelect : this.onSelect.bind(this)
    }
    // data param in coach-box can be deleted
    return(
      <div className="pro_row">
        {this.props.userState==='pro'?
          this.state.is_first?
            <CoachSelection handlers={selectHandlers} state={this.state} />:
            <CoachChat handlers={chatHandlers} state={this.state}/>
          :<UpgradeToPro />
        }
      </div>
    );
  }
}


const mapStateToProps = (state, props) =>{
  return{
    coaches: state.coach.coaches,
    chatLog: state.coach.chatLog,
    chatrooms: state.coach.chatrooms,
    userState: state.auth.userState,
    chatroomId : state.coach.chatroomId
  }
}

const mapDispatchToProps = dispatch =>{
  return{
    getCoaches: ()=>{
      dispatch(action.getCoaches());
    },
    getChatLogs: (chatroomId)=>{
      dispatch(action.getChatLogs(chatroomId));
    },
    postChatRooms: (coachId)=>{
      dispatch(action.postChatRooms(coachId));
    },
    postChat: (content, chatroomId)=>{
      dispatch(action.postChat(content, chatroomId));
    },
    updatePushSetting: (content, chatroomId)=>{
      dispatch(action.updatePushSetting(content, chatroomId));
    },
    subscribe: (topic)=>{
      dispatch(subscribe(topic));
    },
    unsubscribe: (topic)=>{
      dispatch(unsubscribe(topic));
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Coach);



// WEBPACK FOOTER //
// ./src/containers/Pro.Coach.js